export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabPreautorizzato.vue?vue&type=template&id=22e24a30&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabPreautorizzato.vue?vue&type=template&id=22e24a30&
// module id = 894
// module chunks = 0